import { render, staticRenderFns } from "./Disparities.vue?vue&type=template&id=34307660&scoped=true"
import script from "./Disparities.vue?vue&type=script&lang=js"
export * from "./Disparities.vue?vue&type=script&lang=js"
import style0 from "./Disparities.vue?vue&type=style&index=0&id=34307660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34307660",
  null
  
)

export default component.exports